<template>
  <div class="mysubject">
    <div class="title">
      <h2>我的课程</h2>
    </div>
    <ul class="filter">
      <li
        @click="tojoin"
        :class="{'active':joinshow}"
      >已加入课程
      <p></p>
      </li>
      <li
        @click="tokeep"
        :class="{'active':keepshow}"
      >收藏的课程
      <p></p>
      </li>
    </ul>
    <ul class="list">
      <a-empty
        class="empty"
        v-if="list.length==0"
        description="暂无数据"
      />
      <li
        v-else
        v-for="item in list"
        :key="item.id"
        @click='getcourse(item.id)'
      >
        <img
          :src="item.cover"
          alt=""
        >
        <div class="sort">
          <span
            class="nofree"
            v-if="item.isFree==0"
          >会员</span>
          <span
            class="isfree"
            v-else
          >免费</span>
        </div>
        <div class="detail">
          <p
            class="tit"
            :title="item.title"
          >{{item.title}}</p>
          <p class='tea'>{{item.teacher}}</p>
          <div
            class="bart"
            v-if="show"
          >
            <div class="rate">
              <p :style="{width:item.finishedPercentage}"></p>
            </div>
          </div>
          <p v-if="show" class="sub">已学习课程<span>{{item.finishedTask}}</span>/<span>{{item.taskCount}}</span>课时</p>
          <!-- <div class="tag">
                 <p :style="{width:item.finishedPercentage}"></p>
              </div> -->
        </div>
      </li>

    </ul>
    <div class="pagemodel">
      <pagination
        :pagination="pagination"
        @changePage="changePage"
      ></pagination>
    </div>
  </div>
</template>

<script>
import { getcourseApi } from "@/request/api";
import pagination from "@/components/common/pagination";
export default {
  name: "mysubject",
  components: { pagination },
  data() {
    return {
      joinshow: true,
      keepshow: false,
      searchInfo: {
        type: 0,
        page: 1,
        pageSize: 8,
      },
      pagination: { total: "", pageSize: 8 },
      list: [],
      show: true,
      widthclass:true
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getToken(getcourseApi, this.searchInfo, (res) => {
        this.pagination.total = res.data.count;
        this.list = res.data.data

      });
    },
    tojoin() {
      this.joinshow = true;
      this.keepshow = false;
      this.searchInfo.type = 0;
      this.show = true;
      this.init();
      this.widthclass=true
    },
    tokeep() {
      this.widthclass=false
      this.joinshow = false;
      this.keepshow = true;
      this.show = false;
      this.searchInfo.type = 1;
      this.init();
    },
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.init();
    },
    getcourse(id) {
      this.$router.push({ path: "/courseInfo", query: { id:this.$Base64.encode(id) } });
    },
  },
};
</script>
<style>
.empty {
  margin: 0 auto;
  margin-top: 30px;
}
</style>
<style lang="stylus" scoped>
.mysubject {
  margin-bottom: 30px;
  .title {
    height: 45px;
    line-height: 45px;
    overflow: hidden;
    border-bottom:1px solid #eff2f2;
    h2 {
      height:45px;
      line-height: 45px;
      margin-left: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
  }

  .filter {
    display: flex;
    margin-left: 8px;
    margin-top: 20px;

    li {
      width: 130px;
      margin-right: 30px;
      height: 35px;
      line-height: 35px;
      font-size: 16px;
      color: #333333;
      text-align: center;
      cursor pointer
      p{
        width: 21px;
        height: 2px;
        background-color: #f1ce48;
        border-radius: 1px;
        text-align center;
        margin:0 auto;
        display:none
      }
    }

    li:last-child {
      margin-rigth: 0px;
    }

    .active {
      color: #f1ce48;
      font-weight: 600;
      p{
        display:block;
      }
    }
  }

  .list {
    display: flex;
    margin-left: 30px;
    flex-wrap: wrap;
    padding-top: 25px;

    li {
      width:215px;
      position: relative;
      margin-right: 20px;
      background-color: #ffffff;
      cursor: pointer;
      margin-bottom:30px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      &:hover {
        box-shadow: 0px 4px 9px 0px rgba(73, 83, 104, 0.2);
      }

      img {
        width: 215px;
        height: 120px;
      }

      .sort {
        background: rgba(0, 0, 0, 0.3);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 555;

        .nofree {
          width: 34px;
          height: 18px;
          background-color: #ea5442;
          border-radius: 3px;
          color:#fff;
          font-size:12px;
          padding:3px;
        }

        .isfree {
          width: 34px;
          height: 18px;
          background-color: #41b5f1;
          border-radius: 3px;
          color:#fff;
          font-size:12px;
          padding:3px;
        }
      }

      .detail {
        width: 215px;
        border: solid 1px #ebebeb;
        border-top: 0;
        padding-left:11px;
        padding-top:11px;
        padding-right:11px;
        .tit {
          font-size: 14px;
          color: #333333;
          margin-bottom: 0px;
          font-weight: 500;
          font-family: MicrosoftYaHei;
          width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom:9px;
        }
        .tea{
          color:#666;
          font-size:12px;
          margin-bottom: 10px;
        }

        .bart {
          display: flex;
          margin-bottom: 10px;
          align-items: center;
          height: 5px;
          margin-top: 10px;
          background: #ddd;
          .rate {
            width: 215px;
            background: #ddd;
            height: 100%;

            p {
              background-color: #49af4f;
              height: 100%;
            }
          }
        }
        .sub{
          color: #49af4f;
          font-size:12px;
        }
      }
    }
  }

  .pagemodel {
    margin-top: 20px;
  }
}
</style>
